export default {
  noBorder: 'no-border',
  border: 'border',
  retro: 'retro',
};
